export default "__VITE_ASSET__BcJBx96$__"